/*
 *   Copyright (c) 2021 Sok Channy
 *   All rights reserved.
 */
// Copyright 2021 channysok

import React, { useEffect, useState, useCallback } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faBarcode, faBox, faCloudUploadAlt, faCode, faDollarSign, faEdit, faFlag, faHome, faHSquare, faPeopleArrows, faPlug, faQrcode, faRocket, faSearch, faTasks, faTrash, faUserShield } from "@fortawesome/free-solid-svg-icons"
import { Badge, Button, ButtonGroup, Card, Col, Dropdown, Form, Image, InputGroup, Pagination, ProgressBar, Row, Table } from '@themesberg/react-bootstrap'
import { useDispatch, useSelector } from "react-redux"
import WaybillAction from "../../core/redux/action/WaybillAction"
import _ from "lodash"

//import USAFlag from '../../assets/img/flags/united-states-of-america.svg';
import VietnamFlag from '../../assets/img/flags/vietnam.svg';
import ThailandFlag from '../../assets/img/flags/thailand.svg';
import ChinaFlag from '../../assets/img/flags/china.svg';

import PuPagination from "../../components/PuPagination"
import { Routes } from "../../routes"

import WaybillDetailPage from "./WaybillDetailPage"
import AppConfig from "../../core/config/AppConfig"
import { Link } from "react-router-dom"
import NewWaybillPage from "./NewWaybillPage"
import { getUser } from "../../core/auth/authentication"
import { nameFormat, phoneFormat } from "../../core/util/General"
import { faServicestack } from "@fortawesome/free-brands-svg-icons"
import { GetRequest, GetResultObject, PostRequest } from "../../core/API"
import { ApiSrc } from "../../resources/ApiSrc"
import Swal from 'sweetalert2'
import { WaybillStatus } from "./WaybillPage"

const moment = require('moment');

export default (props) => {

  const [user, setUser] = useState()
  useEffect(()=> {
    getUser().then(it=>{
      setUser(it)
    })
  }, [])

  const dispatch = useDispatch();

  const waybillRes = useSelector((state) => state.waybill);
  //const waybills = _.get(waybillRes, "waybillArrivedList.data");
  const pages = _.get(waybillRes, "waybillArrivedList.pages");
  const size = _.get(waybillRes, "waybillArrivedList.size");
  const total = _.get(waybillRes, "waybillArrivedList.total");
  const [currentPage, setCurrentPage] = useState()

  const [accountNo, setAccountNo] = useState()
  const [barcode, setBarcode] = useState()
  const [countryCode, setCountryCode] = useState()
  const [serviceType, setServiceType] = useState()
  const [paid, setPaid] = useState()  
  const [id, setId] = useState()
  const [reference, setReference] = useState()
  const [status, setStatus] = useState()

  const [reminderCount, setReminderCount] = useState(0)

  useEffect(() => {
    GetRequest("https://notification.joonaakhub.com/notification/get_reminder?per_page=1", {}, {}).then(result=>{      
        console.log(">get_reminder", result)
        setReminderCount(_.get(result, 'data.paging.total'))      
    })
    if (_.get(waybillRes, "waybillArrivedList.data") == undefined) {
      fetchData()
    }
  }, [])

  useEffect(() => {
    if(currentPage != undefined) fetchData()
  }, [currentPage])

  // enter to search
  const keyPressFunction = useCallback((event) => {
    if (event.keyCode === 13) {
      fetchData()
    }
  }, [props, status, accountNo, reference, barcode, countryCode, serviceType, paid]);

  useEffect(() => {
    document.addEventListener("keydown", keyPressFunction, false);
    return () => {
      document.removeEventListener("keydown", keyPressFunction, false);
    };
  }, [keyPressFunction]);


  const fetchData = () => {
    dispatch(WaybillAction.getWaybillArrivedList({
      "input": {
        accountNo: accountNo ? `JOONAAK-${accountNo}` : undefined,
        barcode,
        reference,        
        countryCode,        
        pendingArrived: true
      },
      "token": "string"
    }, {
      size: 1000,
      sort: "createdAt,ASC",
      page: currentPage
    }));
  };

  const toggleCheck = (e, item, all) => {
      if(all) {
        _.get(waybillRes, "waybillArrivedList.data").map(item1=>{
            item1.selected = e.target.checked
            dispatch(WaybillAction.updateWaybillArrivedSuccess(item1))    
        })
      } else {
        item.selected = e.target.checked
        dispatch(WaybillAction.updateWaybillArrivedSuccess(item))    
      }       
  } 

  const markArrived = (all) => {
    _.get(waybillRes, "waybillArrivedList.data").map(item=>{
        if(item.selected || all) {
            const body = {
                id: _.get(item, 'id'),
                status: "Arrived",                
            }
                            
            PostRequest(ApiSrc.UPDATE_WAYBILL, {input: {...body}, token: null}).then(result =>            
                GetResultObject(result, 'data', 200, (data) => {                    
                    dispatch(WaybillAction.updateWaybillArrivedSuccess(data))    
                }, error => {
                    console.log(">>error", error)
                })
            )
        }  
    })     
} 

  if (id) {
    return <WaybillDetailPage id={id} onClose={(timer) => {
      dispatch(WaybillAction.clearWaybill())
      setId(undefined)
      clearInterval(timer)
    }} />
  }

  return (
    <>
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center">
        <div className="d-block mb-4 mb-md-0">
          <h4>Waybills Arrived</h4>
          <p className="mb-0"> </p>
        </div>
        <ButtonGroup>
          {/* <Button variant="outline-primary" size="sm" onClick={() => {  }}>Reminder</Button>                   */}
          <Button variant="outline-dark" size="sm" onClick={() => {
            PostRequest(ApiSrc.GET_SETTING, 
                {
                "input": {
                    "key": "notify_url"
                }
                }, {}).then(result => { GetResultObject(result, 'data', 200, data => {
                //console.log(_.get(data, '[0].value'))
                if(_.get(data, '[0].value')) {
                    window.open(_.get(data, '[0].value') , "_blank")
                }                                    
            })})                
            }}>Send reminder<Badge pill bg={"info"} className="badge-md notification-count ms-2">{reminderCount}</Badge></Button>            
        </ButtonGroup>
      </div>
      <Card border="light" className="shadow-sm mb-4">
        <Card.Header>
          <Row>            
            <Col xs={12} sm={6} xl={2}>
              <Form.Group className="mb-4">
                <Form.Label>Account No</Form.Label>
                <InputGroup>
                  <InputGroup.Text>
                    <FontAwesomeIcon icon={faUserShield} />
                  </InputGroup.Text>
                  <Form.Control required type="text" 
                    onChange={(e) => { setAccountNo(e.target.value == '' ? undefined : e.target.value) }} />
                </InputGroup>
              </Form.Group>
            </Col>
            <Col xs={12} sm={6} xl={3}>
              <Form.Group className="mb-4">
                <Form.Label>Reference#</Form.Label>
                <InputGroup>
                  <InputGroup.Text>
                    <FontAwesomeIcon icon={faBox} />
                  </InputGroup.Text>
                  <Form.Control required type="text"
                    onChange={(e) => setReference(e.target.value == '' ? undefined : e.target.value)} />
                </InputGroup>
              </Form.Group>
            </Col>
            <Col xs={12} sm={6} xl={3}>
              <Form.Group className="mb-4">
                <Form.Label>Barcode#</Form.Label>
                <InputGroup>
                  <InputGroup.Text>
                    <FontAwesomeIcon icon={faQrcode} />
                  </InputGroup.Text>
                  <Form.Control required type="text" 
                    onChange={(e) => setBarcode(e.target.value == '' ? undefined : e.target.value)} />
                </InputGroup>
              </Form.Group>
            </Col>
            <Col xs={12} sm={6} xl={2}>
              <Form.Group className="mb-3">
                <Form.Label>Country</Form.Label>
                <InputGroup>
                  <Form.Select onChange={(e) => {
                    //console.log('>value', e.target.value)                        
                    setCountryCode(e.target.value == "--Select--" ? undefined : e.target.value)
                  }}>
                    <option>--Select--</option>
                    <option value="86">China</option>
                    <option value="66">Thailand</option>
                    <option value="84">Vietnam</option>                    
                  </Form.Select>
                </InputGroup>
              </Form.Group>
            </Col>
            <Col xs={12} sm={6} xl={2}>
              <Form.Group className="mb-4 float-end" style={{ paddingTop: 30 }}>
                <Button onClick={fetchData}><FontAwesomeIcon icon={faSearch} /> Search</Button>
              </Form.Group>
            </Col>
          </Row>
         
          
        </Card.Header>
        <Card.Body>
        <ButtonGroup>
          <Button variant="outline-primary" size="sm" onClick={() => { markArrived() }}>Arrived</Button>
          <Button variant="outline-primary" size="sm" onClick={() => { markArrived(true) }}>Arrived All</Button>
        </ButtonGroup>
        </Card.Body>
        <Card.Body className="pb-0">
          <Table responsive className="table-centered table-nowrap rounded mb-0">
            <thead className="thead-light">
              <tr>
                {/* <th className="border-0" width={30}>#</th>                                 */}
                <th className="border-0" width={30}>
                    <input type="checkbox"  
                        checked={
                            _.get(waybillRes, "waybillArrivedList.data", []).filter(item1=> { 
                                if(item1.selected != true) return item1 
                            }).length <= 0
                        }
                        onClick={e=>{toggleCheck(e, null, true)}} />
                </th>
                <th className="border-0">Status</th>
                <th className="border-0">Arrived Time</th>
                <th className="border-0">Reference#</th>
                <th className="border-0">Account#</th>                
              </tr>
            </thead>
            <tbody>
              {
                //receivers && receivers.map()
                _.get(waybillRes, 'waybillArrivedList.data') && _.get(waybillRes, 'waybillArrivedList.data').map((item, index) => {
                  console.log(">>item", item)
                  return (
                    <tr>
                      {/* <td>{(index + 1) + (AppConfig.pageSize * (currentPage ?? 0))}</td>                                             */}
                      <td><input type="checkbox" checked={item.selected} onClick={e=>{toggleCheck(e, item, false)}} /></td>
                      <td align="left">
                        <WaybillStatus item={item} />                      
                      </td>


                      <td>{moment(_.get(item, 'arrivedAt')).format('DD MM,YYYY HH:mm')}</td>

                      <td align="left">
                        <Image src={GetCountryFlag(_.get(item, 'countyCode'))} className="image-small me-2" />{_.get(item, 'reference', '')}
                        <br /><small className="text-mute" style={{fontSize: '8pt', color: 'green'}}>{_.get(item, 'barcode', '')}</small>
                      </td>
                      
                      <td>
                        {_.get(item, 'warehouse.accountNo', '')}
                        <br /><small className="text-mute" style={{fontSize: '8pt', color: 'green'}}>{ nameFormat(_.get(item, 'receiver')) }</small>
                        <br /><small className="text-mute" style={{fontSize: '8pt', color: 'green'}}>{ phoneFormat(_.get(item, 'receiver')) }</small>
                      </td>             
                    </tr>
                  )
                })
              }
            </tbody>
          </Table>
        </Card.Body>
        <Card.Footer>
          <PuPagination size={size} total={total} currentPage={currentPage} totalPage={pages} onChange={setCurrentPage} />
        </Card.Footer>
      </Card>
    </>
  )
}

const GetCountryFlag = (countryCode) => {
  console.log('> countryCode', countryCode)
  switch (countryCode) {
    case '86': return ChinaFlag
    case '84': return VietnamFlag
    case '66': return ThailandFlag
    default: return null
  }
}
//'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info' | 'dark' | 'light'